import { render, staticRenderFns } from "./GlanceTable.vue?vue&type=template&id=29dff824&scoped=true"
import script from "./GlanceTable.vue?vue&type=script&lang=js"
export * from "./GlanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dff824",
  null
  
)

export default component.exports